const ITEMS = ["Modded accounts", "PC accounts", "Stacked bank", "Max rank", "Every car", "Pay by card", "Apple Pay", "PayPal", "Crypto", "Cash App"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className={`font-display px-8 text-6xl uppercase md:text-8xl ${i % 3 === 1 ? "text-stroke" : "text-white/90"}`}>{t}</span>
        <span className="h-3 w-3 rotate-45 bg-[#ff3dc8] shadow-[0_0_14px_#ff3dc8]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative overflow-hidden border-y border-white/10 bg-[#0b0b11] py-8" data-testid="editorial-marquee">
    <div className="marquee-track">
      <Row />
      <Row hidden />
    </div>
  </section>
);
